var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "#3664A7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 14.6959V24.3977C11.0737 22.2965 8.99997 18.7426 8.99997 14.6959C8.99997 8.23672 14.2762 3.02267 20.8125 3.02267C27.3487 3.02267 32.625 8.23672 32.625 14.6959C32.625 18.7426 30.5512 22.2965 27.375 24.3977V14.6959C27.375 11.1161 24.435 8.21078 20.8125 8.21078C17.19 8.21078 14.25 11.1161 14.25 14.6959ZM24.6778 27.2102C25.259 27.2102 25.8215 27.3414 26.3465 27.6039L33.9965 31.4102C35.4403 32.1227 36.2653 33.6977 36.0403 35.2914L34.859 43.6727C34.5965 45.5289 33.0215 46.8977 31.1465 46.8977H19.709C18.7153 46.8977 17.759 46.5039 17.0465 45.8102L9.52775 38.2914C8.7215 37.4664 8.7215 36.1539 9.52775 35.3289C10.034 34.8227 10.7653 34.5977 11.459 34.7477L17.909 36.0977V15.9602C17.909 14.4039 19.1653 13.1477 20.7215 13.1477C22.2778 13.1477 23.534 14.4039 23.534 15.9602V27.2102H24.6778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.7148a1e78ac62270dab4dfba36164b19.svg";
export { ForwardRef as ReactComponent };